import { render, staticRenderFns } from "./LetterStepPricing.vue?vue&type=template&id=3b0699ff&scoped=true&"
import script from "./LetterStepPricing.vue?vue&type=script&lang=ts&"
export * from "./LetterStepPricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0699ff",
  null
  
)

export default component.exports